import { NgModule } from '@angular/core';
//import { BrowserModule } from '@angular/platform-browser';
//import { HttpClientModule } from '@angular/common/http';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
//import 'hammerjs';

import { FuseModule } from './../@fuse/fuse.module';
import { FuseSharedModule } from './../@fuse/shared.module';
import { FuseProgressBarModule } from './../@fuse/components/progress-bar/progress-bar.module';
import { FuseSidebarModule } from './../@fuse/components/sidebar/sidebar.module';

import { fuseConfig } from './fuse-config';

import { AppComponent } from './app.component';
//import { AppStoreModule } from './store/store.module';
import { LayoutModule } from './layout/layout.module';
import { MaterialModule } from './main/angular-material-elements/material.module';
import { EcapBroadcastService } from '../ecap/services/ecap-broadcast.service';

@NgModule({
    declarations: [AppComponent],
    imports: [
        MaterialModule,
        //BrowserModule,
        //BrowserAnimationsModule,
        //HttpClientModule,

        TranslateModule.forRoot(),

        // Material moment date module
        //MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,

        // App modules
        LayoutModule
        // AppStoreModule
    ],
    providers: [EcapBroadcastService],
    bootstrap: [AppComponent],
    exports: [AppComponent]
})
export class AppModule {}
